import { Box, Flex, Button, Progress, Link, Heading } from '@chakra-ui/react'
import React, { useState } from 'react'
import { TARM_AWS_URL } from '../../api/api'

const DownloadResults = ({ author_email, run_id }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [rankingLink, setRankingLink] = useState('')
    const [smartRecruiterLink, setSmartRecruiterLink] = useState('')
    const [CIDLink, setCIDLink] = useState('')

    const getPresignedLink = async (filename) => {
        try {
            setIsLoading(true)
            const response = await TARM_AWS_URL.get("get-presigned-url", {
                params: {
                    author_email: author_email,
                    run_id: run_id,
                    filename: filename
                }
            })
            const link = response.data.signed_url
            if (filename === 'Ranking_Output.zip') {
                setRankingLink(link)
            } else if (filename === 'smartrecruiter_status.csv') {
                setSmartRecruiterLink(link)
            } else if (filename === 'cid.xlsx') {
                setCIDLink(link)
            }
        } catch (error) {
            console.error(error.message)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Box>
            <Heading as="h4" size="md" mb="4">
                Download Results
            </Heading>
            <Flex>
                <Box textAlign="center">
                    <Button colorScheme='teal' variant='ghost' onClick={() => getPresignedLink('Ranking_Output.zip')}>
                        Ranking Output
                    </Button>
                    {
                        rankingLink &&
                        <Box>
                            <Link color='blue.500' href={rankingLink}>
                                Ranking_Output.zip
                            </Link>
                        </Box>
                    }
                </Box>
                {/* <Spacer />
                <Box textAlign="center">
                    <Button colorScheme='teal' variant='ghost' onClick={() => getPresignedLink('smartrecruiter_status.csv')}>
                        Smartrecruiter Status
                    </Button>
                    {
                        smartRecruiterLink &&
                        <Box>
                            <Link color='blue.500' href={smartRecruiterLink}>
                                smartrecruiter_status.csv
                            </Link>
                        </Box>
                    }
                </Box>
                <Spacer />
                <Box textAlign="center">
                    <Button colorScheme='teal' variant='ghost' onClick={() => getPresignedLink('cid.xlsx')}>
                        Candidate ID file
                    </Button>
                    {
                        CIDLink &&
                        <Box>
                            <Link color='blue.500' href={CIDLink}>
                                cid.xlsx
                            </Link>
                        </Box>
                    }
                </Box> */}
            </Flex>
            <br />
            {
                isLoading &&
                <Progress size='xs' isIndeterminate={isLoading} />
            }
        </Box>

    )
}

export default DownloadResults